/* Original Tabby direct-purchase controls; generic page UI is in yp-express.js. */
(() => {
	const root = document.querySelector('[data-v3][data-yp-page="tabby"]');
	if (!root || root.dataset.ypCampaignBound === "true") return;
	root.dataset.ypCampaignBound = "true";
	const analytics = window.YPAnalytics;
	const buttons = [...root.querySelectorAll("[data-yp-campaign-buy]")];
	const original = new Map(buttons.map((button) => [button, {html: button.innerHTML, disabled: button.disabled}]));
	let pending = false;
	const reset = () => {
		pending = false;
		buttons.forEach((button) => {
			button.innerHTML = original.get(button).html;
			button.disabled = original.get(button).disabled;
			delete button.dataset.loading;
			button.removeAttribute("aria-busy");
		});
	};
	buttons.forEach((button) => button.addEventListener("click", () => {
		if (pending || button.disabled || !button.dataset.ypCampaignUrl) return;
		const error = button.closest("article").querySelector("[data-yp-campaign-error]");
		try {
			const url = new URL(button.dataset.ypCampaignUrl, window.location.origin);
			if (url.origin !== window.location.origin || !url.pathname.endsWith(`/cart/${button.dataset.ypVariant}:1`)
				|| !url.searchParams.has("checkout") || url.searchParams.get("attributes[checkout_method]") !== "tabbyonly") {
				throw new Error("Invalid Tabby checkout destination");
			}
			root.querySelectorAll("[data-yp-campaign-error]").forEach((item) => {item.hidden = true;});
			pending = true;
			buttons.forEach((item) => {item.disabled = true;});
			button.dataset.loading = "true";
			button.setAttribute("aria-busy", "true");
			button.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" style="display:block;animation:yp-spin 0.8s linear infinite" aria-hidden="true"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="56.55" stroke-dashoffset="40" opacity="0.9"></circle></svg>';
			analytics?.trackButtonClick(`tabby_buy_${button.dataset.ypCampaignBuy}`);
			analytics?.trackCheckoutStart(analytics.checkoutSku(url.href));
			window.location.assign(analytics?.decorateCheckoutURL(url.href) || url.href);
		} catch {
			// A caught local navigation failure, not a remote payment outcome.
			analytics?.trackCheckoutError(analytics.checkoutSku(button.dataset.ypCampaignUrl));
			reset();
			if (error) error.hidden = false;
		}
	}));
	window.addEventListener("pageshow", (event) => {if (event.persisted) reset();});
})();
